<!--suppress HtmlUnknownAttribute -->
<p-toast key="2faMessage" position="top-center"></p-toast>
<div class="ml-8 login-container join" [ngClass]="parent.isDesktopDevice ? 'all-color ' + currentStage : 'login-mobile all-color ' + currentStage" >
  <h1 class="text-center">Welcome to Adcore Media Blast!</h1>
  <h2 class="text-center mt-2">Complete Your Sign Up</h2>
  <form autocomplete="off" *ngIf="currentStage === 'stage2'" class="mt-4">
    <ng-container>
      <small class="login-error mb-1" id="fullName-error" *ngIf="fullNameError">{{fullNameError}}</small>
      <div class="flex field fluid mb-3">
        <label *ngIf="!parent.isDesktopDevice">First Name*</label>
        <input id="firstName" name="firstName" type="text" pInputText placeholder="First Name*"
               [(ngModel)]="loginInfo.firstName" autocomplete="off" [ngModelOptions]="{standalone: true}"
               [required]="true" class="mr-3" autofocus
               [disabled]="inProcess"/>
        <label *ngIf="!parent.isDesktopDevice">Last Name*</label>
        <input id="lastName" name="lastName" type="text" pInputText placeholder="Last Name*"
               [(ngModel)]="loginInfo.lastName" autocomplete="off" [ngModelOptions]="{standalone: true}"
               [required]="true" [disabled]="inProcess"/>
      </div>
    </ng-container>
    <div class="field fluid mb-3 phone" [ngClass]="{'invalid-border': phoneError}">
      <small class="login-error mb-1" id="phone-error" *ngIf="phoneError">{{phoneError}}</small>
      <aux-phone #phone [countryCode]="currentCountryCode" (phoneChangeEvent)="phoneError=null"
                 [showExamplePlaceholder]="false" placeholder="Mobile Phone*" [autofocus]="false">
      </aux-phone>
    </div>
    <div class="field fluid mb-3" [ngClass]="{'invalid-border': websiteError}">
      <label *ngIf="!parent.isDesktopDevice">Your company website*</label>
      <small class="login-error mb-1" id="website-error" *ngIf="websiteError">{{websiteError}}</small>
      <input id="websiteUrl" name="websiteUrl" type="text" pInputText placeholder="Your company website*"
             [(ngModel)]="loginInfo.websiteUrl" autocomplete="off" [ngModelOptions]="{standalone: true}"
             [required]="true" [disabled]="inProcess" (keyup)="removeError('website')"/>
    </div>
    <ng-container>
      <div *ngIf="passwordError">
        <small class="login-error" id="password-error">{{passwordError}}</small>
      </div>
      <div [ngClass]="{'new-pwd-container': parent.isDesktopDevice}">
        <div class="field fluid mb-3 new-pwd">
          <label *ngIf="!parent.isDesktopDevice">Enter Password* <aux-info class="center-tip" [content]="passwordRequirement"></aux-info></label>
          <p-password [(ngModel)]="loginInfo.pass1" [feedback]="false"
                      [toggleMask]="true" [required]="true"  [disabled]="inProcess"
                      (ngModelChange)="checkPasswordStrength($event)"
                      [ngClass]="{'invalid-border': showPasswordFeedback}"
                      placeholder="Enter Password*" [ngModelOptions]="{standalone: true}">
          </p-password>
        </div>
        <aux-info *ngIf="parent.isDesktopDevice" class="center-tip" [content]="passwordRequirement"></aux-info>
      </div>
      <ng-container *ngIf="showPasswordFeedback" >
        <aux-strong-pwd-feedback [passwordCriteria]="passwordCriteria" [column]="2"></aux-strong-pwd-feedback>
      </ng-container>
      <div class="field fluid" [ngStyle]="{'margin-bottom' : !parent.isDesktopDevice ? '0' : '15px'}">
        <label *ngIf="!parent.isDesktopDevice">Re-Enter Password*</label>
        <p-password [(ngModel)]="loginInfo.pass2" [feedback]="false"
                    [toggleMask]="true" [required]="true" [disabled]="inProcess"
                    placeholder="Re-Enter Password*" [ngModelOptions]="{standalone: true}"></p-password>
      </div>
    </ng-container>
    <div *ngIf="responseError">
      <small class="login-error" id="response-error1">{{responseError}}</small>
    </div>
    <div class="field fluid mb-3 text-center" *ngIf="!failedReCaptchaV3">
      <p-button [label]="inProcess ? '': 'CONTINUE'" styleClass="login-btn-secondary" (onClick)="join()" [disabled]="inProcess">
        <div class="loader-box-dots" *ngIf="inProcess">
          <div class="loader">
            <div></div>
          </div>
        </div>
      </p-button>
    </div>
  </form>
  <div *ngIf="currentStage === 'stage2-verifyPhone'">
    <div class="field fluid mb-3 mt-4">
      <div class="mb-3">
        <div>We need a valid mobile number to keep your account secure when login. </div>
        <div>A 6-digit code has been sent to {{loginInfo.phoneNumber}}. </div>
        <div>Enter the code below to verify your phone number.</div>
      </div>
      <div class="card flex justify-content-center" [ngClass]="{'invalid-border': codeError, 'green-border': phoneCodeCorrect}">
        <p-inputOtp [(ngModel)]="phoneCode" [ngModelOptions]="{standalone: true}" [integerOnly]="true" [length]="6"
                    class="verify-code" (onChange)="onCodeChange($event)"/>
      </div>
      <small class="login-error mb-1" *ngIf="codeError">Invalid verification code</small>
      <small class="login-error green-text mb-1" *ngIf="phoneCodeCorrect">Validation Successful</small>
      <small class="login-error mb-1" *ngIf="responseError">{{responseError.includes('already exists') ? responseError : 'We are meeting some error, please contact Adcore support.'}}</small>
      <div class="verify-links">
        <p-button styleClass="p-button-link" label="Resend verification code" (onClick)="send2faRequest('resend')" [disabled]="inProcess || resendTimes >= 6 || isResendDisabled" [link]="true"></p-button>
        <ng-container>
          <div class="or">OR</div>
          <p-button styleClass="p-button-link" label="Update phone number" (onClick)="changePhone()" [disabled]="inProcess || isResendDisabled" [link]="true"></p-button>
        </ng-container>
        <ng-container *ngIf="isResendDisabled">
          <div class="countdown">({{countdown}} seconds)</div>
        </ng-container>
      </div>
      <p-button *ngIf="!changePhoneStage" [label]="inProcess ? '': 'VERIFY CODE'" styleClass="login-btn-secondary"
                (onClick)="onApplyingPhoneCode()" [disabled]="inProcess">
        <div class="loader-box-dots" *ngIf="inProcess">
          <div class="loader">
            <div></div>
          </div>
        </div>
      </p-button>
      <div class="change-e" *ngIf="changePhoneStage">
        <div class="field fluid mb-3 phone" [ngClass]="{'invalid-border': newPhoneError}">
          <small class="login-error mb-1" id="phone-error-2" *ngIf="newPhoneError">{{newPhoneError}}</small>
          <aux-phone #newPhone [countryCode]="currentCountryCode" (phoneChangeEvent)="newPhoneError=null"
                     [showExamplePlaceholder]="false" placeholder="Mobile Phone*">
          </aux-phone>
        </div>
        <div class="field fluid mb-3 text-center">
          <p-button [label]="inProcess ? '': 'UPDATE PHONE'" styleClass="login-btn-secondary" (onClick)="updatePhone()"
                    [disabled]="inProcess">
            <div class="loader-box-dots" *ngIf="inProcess">
              <div class="loader">
                <div></div>
              </div>
            </div>
          </p-button>
        </div>
      </div>
    </div>
  </div>
</div>
